import React, { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  setAvaliableOrganizations,
  setOrganization
} from '../redux/actions/OrganizationActions'
import { setUserData } from '../redux/actions/UserActions'
import { setCaseTypes } from '../redux/actions/CaseDataActions'
import localStorageService from '../services/localStorageService'
import sfAuthService from '../services/sfAuth/SFAuthService'
import { userLoggedIn, userLoggedOut } from '../redux/actions/LoginActions'
import { useHistory, useLocation } from 'react-router'
import { setConfigurationData } from '../redux/actions/ConfigurationActions'
import { Typography } from '@material-ui/core'
import { setTutorialsFromSteps } from 'app/redux/actions/TutorialsActions'
import sfOauthConfig from '../services/sfAuth/sfAuthConfig'
import { grpcGlobalLogin } from 'app/services/grpcMultiuserGlobal'
import { pingServer } from 'app/views/forms/multiuser/grpcMultiuserEdit'
import Loading from 'egret/components/EgretLoadable/Loading'
import { authRoles, hasRole } from './authRoles'
const crypto = require('crypto')

const Auth = ({ children, maintenance }) => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const { login, user } = useSelector(state => state)

  useEffect(() => {
    let user = localStorageService.getItem('auth_user')
    dispatch(setUserData(user))
    if (!maintenance) {
      checkSfAuth(user)
    }
  }, [])

  // useEffect(() => {
  //   const reset = function (event) {
  //     if (event.key === 'z') {
  //       console.log('fake log out')
  //       dispatch(
  //         setUserData({
  //           ...user,
  //           fake: crypto.randomBytes(8).toString('hex'),
  //           multiuserAuthenticated: false
  //         })
  //       )
  //     }
  //   }
  //   document.addEventListener('keydown', reset)
  //   return () => {
  //     document.removeEventListener('keydown', reset)
  //   }
  // }, [])

  useEffect(() => {
    let handle
    if (user.multiuserLoginToken) {
      handle = setInterval(() => {
        pingServer({
          userId: user.userId,
          token: user.multiuserLoginToken,
          onReject: () => {
            console.log('global ping fail')
            dispatch(
              setUserData({
                ...user,
                multiuserAuthenticated: false
              })
            )
          },
          onSuccess: () => {
            console.log('global ping success')
          }
        })
      }, 4000)
    }

    return () => {
      clearInterval(handle)
    }
  }, [user.multiuserLoginToken])

  useEffect(() => {
    if (
      !user.multiuserAuthenticated &&
      user.access_token &&
      hasRole(user.role, authRoles.tester) &&
      !sfOauthConfig.isIcce
    ) {
      console.log('try login')
      grpcGlobalLogin({
        token: user.access_token,
        userId: user.userId,
        username: user.displayName,
        userInfo: JSON.stringify({}),
        onSuccess: ({ sessionToken }) => {
          console.log('success global login', sessionToken)
          dispatch(
            setUserData({
              ...user,
              multiuserAuthenticated: true,
              multiuserLoginToken: sessionToken
            })
          )
        },
        onFail: result => {
          console.log('failed global login', result)
          //dispatch(setUserData(user))
        }
      })
    }
  }, [user])

  const checkSfAuth = user => {
    let sentState = {
      redirect_uri: location.pathname
    }
    console.log('match', location, login, user, user && user.access_token)
    if (login.success) {
      console.log('user logged in')
    } else if (user && user.access_token && user.userId) {
      console.log('read user saved', user)
      sfAuthService
        .checkLogin(user)
        .then(
          ({ user, state, configuration, tutorialSteps }) => {
            dispatch(setUserData(user))
            dispatch(setConfigurationData(configuration))
            sfAuthService.setUser(user)
            dispatch(userLoggedIn())
          },
          e => {
            console.error('user check failed', e, user)
            sfAuthService.setUser(null)
            dispatch(userLoggedOut())
            sfAuthService.doLogin(sentState)
          }
        )
        .catch(e => {
          console.error('cant login from stored user', e, login)
          sfAuthService.setUser(null)
          dispatch(userLoggedOut())
          sfAuthService.doLogin(sentState)
        })
    } else {
      sfAuthService
        .parseToken()
        .then(
          ({
            user,
            state,
            organization,
            configuration,
            tutorialSteps,
            caseTypes,
            avaliableOrganizations
          }) => {
            dispatch(setOrganization(organization))
            dispatch(setConfigurationData(configuration))
            dispatch(setTutorialsFromSteps(tutorialSteps))
            dispatch(setAvaliableOrganizations(avaliableOrganizations))
            dispatch(setCaseTypes(caseTypes))
            dispatch(userLoggedIn())
            dispatch(setUserData(user))

            try {
              console.log('redirect', state, history.location.pathname)
              if (
                !String(history.location.pathname).includes(
                  'ApplicantInformation'
                ) ||
                // always redirect on internal, skip validity check
                sfOauthConfig.isInternal
              ) {
                history.push({
                  pathname: state.redirect_uri
                })
              }
            } catch (e) {
              console.error("can't redirect going to root", e, user, state)
              // window.location = '/'
            }
          }
        )
        .catch(e => {
          console.error('cant login', e, login)
          sfAuthService.doLogin(sentState)
        })
    }
  }

  if (maintenance) {
    return (
      <>
        <div
          style={{
            position: 'fixed',
            left: 0,
            textAlign: 'center',
            right: 0,
            top: 'calc(50% - 100px)',
            margin: 'auto',
            height: '200px',
            width: '400px'
          }}
        >
          <Typography variant='h6'>
            Temporarily Under Maintenance
            <br />
            We'll be back shortly
          </Typography>
          <br />
          <br />
          <Typography variant='h6'>
            Temporairement en maintenance
            <br />
            Nous serons bientôt de retour
          </Typography>
        </div>
      </>
    )
  }
  return <Fragment>{children}</Fragment>
}

export default Auth
